import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const letters = "ZIRSEN".split("");

export const Preloader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / 1700, 1);
      setProgress(Math.round(100 * (1 - Math.pow(1 - p, 2.4))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#030712]"
      exit={{ clipPath: "inset(0 0 100% 0)", transition: { duration: 0.7, ease: [0.83, 0, 0.17, 1] } }}
    >
      {/* soft breathing atmosphere — matches the site background */}
      <motion.div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[110px]"
        style={{ background: "radial-gradient(circle, rgba(0,245,212,0.10) 0%, transparent 70%)" }}
        animate={{ scale: [1, 1.18, 1], opacity: [0.65, 1, 0.65] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
      />

      <motion.div
        initial={{ scale: 0.82, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <motion.div
          className="absolute -inset-8 rounded-full"
          animate={{ boxShadow: ["0 0 0 0 rgba(0,245,212,0.28)", "0 0 70px 14px rgba(0,245,212,0.12)", "0 0 0 0 rgba(0,245,212,0.28)"] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
        />
        <img src="/logo-icon-light.png" alt="ZIRSEN" className="h-24 w-auto" />
      </motion.div>

      <div className="mt-8 flex overflow-hidden">
        {letters.map((l, i) => (
          <motion.span
            key={i}
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.35 + i * 0.07, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-2xl font-bold tracking-[0.4em] text-white"
          >
            {l}
          </motion.span>
        ))}
      </div>

      {/* elegant hairline progress */}
      <div className="mt-10 h-px w-56 overflow-hidden bg-white/10">
        <motion.div className="h-full bg-teal-400" style={{ width: `${progress}%` }} />
      </div>
      <p className="font-mono mt-4 text-[11px] font-medium tracking-[0.35em] text-slate-500">{progress} %</p>
    </motion.div>
  );
};
